import miller from '../images/clients-section/Miller-Coors.png'
import beam from '../images/clients-section/beam-suntory-logo2.png'
import jarritos from '../images/clients-section/jarritos.png'
import pepsico from '../images/clients-section/logo_pepsico.png'
import modelo from '../images/clients-section/ModeloSAB11.jpg'
import busch from '../images/clients-section/Anheuser_Busch.png'
import moctezuma from '../images/clients-section/Cuauhtemoc-Moctezuma-Holding-–-Tecate-Beer.png'
import dickies from '../images/clients-section/dickies.jpg'
import metroByT from '../images/clients-section/MetroByT-Mobile.png'
import boost from '../images/clients-section/boostmobile.png'
import cricket from '../images/clients-section/cricket.png'
import homedepot from '../images/clients-section/home-depot.png'
import lowes from '../images/clients-section/lowes.jpg'
import hdsupply from '../images/clients-section/hdsupply.png'
import lcalottery from '../images/clients-section/lcalottery.png'
import dewalt from '../images/clients-section/dewalt.jpg'
import medicaid from '../images/clients-section/medicaid.png'
import tobacco from '../images/clients-section/tobacco-free-ca.jpg'
import reilly from '../images/clients-section/reilly-auto-parts.png'
import espn from '../images/clients-section/espn.png'
import telemundo from '../images/clients-section/telemundo.png'
import azteca from '../images/clients-section/tv-azteca.jpg'
import western from '../images/clients-section/western-union.png'
import money from '../images/clients-section/money-gram.png'
import xcel from '../images/clients-section/xcel-energy.png'
import cdc from '../images/clients-section/CDC-Logo.png'
import california from '../images/clients-section/california-state-parks.png'
import metropolitan from '../images/clients-section/metropolitan-water-district.jpg'
import endowment from '../images/clients-section/the-california-endownment.png'
import volaris from '../images/clients-section/volaris.png'
import nongshim from '../images/clients-section/nongshim.png'
import bandai from '../images/clients-section/bandai-namco.png'
import glidden from '../images/clients-section/glidden.jpg'
import tums from '../images/clients-section/tums-logo.png'
import tampico from '../images/clients-section/tampico.png'
//new image :
import aetna from '../images/clients-section/aetna.png'
import altamed from '../images/clients-section/altamed.jpg'
import anthem from '../images/clients-section/anthem.png'
import burnet from '../images/clients-section/burnetcountytexas.png'
import calfire from '../images/clients-section/calfire.png'
import canohealth from '../images/clients-section/canohealth.png'
import cccco from '../images/clients-section/cccco.png'
import cdhs from '../images/clients-section/cdhs.png'
import cdph from '../images/clients-section/cdph.png'
import dbw from '../images/clients-section/dbw.png'
import cdphe from '../images/clients-section/cdphe.png'
import chenmend from '../images/clients-section/chenmed.jpg'
import christiana from '../images/clients-section/christianacare.png'
import clchc from '../images/clients-section/clchc.jpg'
import communitycaretx from '../images/clients-section/communitycaretx.jpg'
import communitymedical from '../images/clients-section/communitymedicalgroup.jpg'
import connecthealth from '../images/clients-section/connectforhealthco.png'
import coronatools from '../images/clients-section/coronatools.png'
import cppa from '../images/clients-section/cppa.png'
import cpw from '../images/clients-section/cpw.png'
import democracy from '../images/clients-section/democracyprep.png'
import dhs from '../images/clients-section/dhs.png'
import dir from '../images/clients-section/dir.png'
import evergy from '../images/clients-section/evergy.png'
import elpasocounty from '../images/clients-section/elpasocountyhealth.png'
import fcc from '../images/clients-section/fcc.png'
import felixpago from '../images/clients-section/felixpago.png'
import frcsj from '../images/clients-section/frcsj.png'
import freetaxprep from '../images/clients-section/freetaxprepla.png'
import hhs from '../images/clients-section/hhs.png'
import housing from '../images/clients-section/housing.png'
import innovacare from '../images/clients-section/innovacarehealth.png'
import islanddoctors from '../images/clients-section/islanddoctors.png'
import iwantthekit from '../images/clients-section/iwantthekit.png'
import listoscalifornia from '../images/clients-section/listoscalifornia.jpg'
import liftthelabel from '../images/clients-section/liftthelabel.png'
import madrinas from '../images/clients-section/madrinasinsurance.png'
import mycare from '../images/clients-section/mycaremedicalgroup.png'
import mybambu from '../images/clients-section/mybambu.png'
import myfcp from '../images/clients-section/myfcph.jpg'
import mymaxdoc from '../images/clients-section/mymaxdoc.png'
import ncdhhs from '../images/clients-section/ncdhhs.png'
import oneten from '../images/clients-section/oneten.png'
import palmmedical from '../images/clients-section/palmmedicalcenters.jpg'
import pcc from '../images/clients-section/pcc.png'
import qckinetix from '../images/clients-section/qckinetix.png'
import recoverforlife from '../images/clients-section/recoverforlife.png'
import remitly from '../images/clients-section/remitly.png'
import sonomacounty from '../images/clients-section/sonomacounty.png'
import spraydays from '../images/clients-section/spraydays.png'

export const clients = [
  {
    key: 'spraydays',
    alt: 'Spraydays',
    img: spraydays,
    link: 'https://spraydays.cdpr.ca.gov/',
  },
  {
    key: 'sonomacounty',
    alt: 'Sonomacounty',
    img: sonomacounty,
    link:
      'https://sonomacounty.ca.gov/health-and-human-services/health-services',
  },
  {
    key: 'remitly',
    alt: 'Remitly',
    img: remitly,
    link: 'https://www.remitly.com/',
  },
  {
    key: 'recoverforlife',
    alt: 'Recoverforlife',
    img: recoverforlife,
    link:
      'https://recoverforlife.myfcph.org/get-help/recovery-and-peer-support/',
  },
  {
    key: 'qckinetix',
    alt: 'Qckinetix',
    img: qckinetix,
    link: 'https://qckinetix.com/florida/ ',
  },
  { key: 'pcc', alt: 'Pcc', img: pcc, link: 'https://pcc-med.com/about/' },
  {
    key: 'palmmedical',
    alt: 'Palmmedical',
    img: palmmedical,
    link: 'https://palmmedicalcenters.com/',
  },
  {
    key: 'oneten',
    alt: 'Oneten',
    img: oneten,
    link: 'https://oneten.org/',
  },
  {
    key: 'ncdhhs',
    alt: 'Ncdhhs',
    img: ncdhhs,
    link: 'https://www.ncdhhs.gov/',
  },
  {
    key: 'mymaxdoc',
    alt: 'Mymaxdoc',
    img: mymaxdoc,
    link: 'https://mymaxdoc.com/',
  },
  {
    key: 'myfcp',
    alt: 'Myfcp',
    img: myfcp,
    link: 'https://myfcph.org/harm-reduction/',
  },
  {
    key: 'mycare',
    alt: 'Mycare',
    img: mycare,
    link: 'https://www.mycaremedicalgroup.com/',
  },
  {
    key: 'mybambu',
    alt: 'Mybambu',
    img: mybambu,
    link: 'https://mybambu.com/en/ ',
  },
  {
    key: 'madrinas',
    alt: 'Madrinas',
    img: madrinas,
    link: 'https://madrinasinsurance.com/',
    bg: true,
  },
  {
    key: 'liftthelabel',
    alt: 'Liftthelabel',
    img: liftthelabel,
    link: 'https://liftthelabel.org/',
    bg: true,
  },
  {
    key: 'listoscalifornia',
    alt: 'Listoscalifornia',
    img: listoscalifornia,
    link: 'https://www.listoscalifornia.org/',
  },
  {
    key: 'iwantthekit',
    alt: 'Iwantthekit',
    img: iwantthekit,
    link: 'https://iwantthekit.org/',
  },
  {
    key: 'islanddoctors',
    alt: 'Islanddoctors',
    img: islanddoctors,
    link: 'https://islanddoctors.com/',
    bg: true,
  },
  {
    key: 'innovacare',
    alt: 'Innovacare',
    img: innovacare,
    link: 'https://innovacarehealth.com/',
  },
  {
    key: 'housing',
    alt: 'Housing',
    img: housing,
    link: 'https://housing.lacity.gov/',
  },
  {
    key: 'hhs',
    alt: 'Hhs',
    img: hhs,
    link: 'https://www.hhs.texas.gov/services/health',
  },
  {
    key: 'freetaxprep',
    alt: 'Freetaxprep',
    img: freetaxprep,
    link: 'https://www.freetaxprepla.com/',
  },
  { key: 'frcsj', alt: 'Frcsj', img: frcsj, link: 'https://frcsj.org/' },
  {
    key: 'felixpago',
    alt: 'Felixpago',
    img: felixpago,
    link: 'https://www.felixpago.com/en',
  },
  { key: 'fcc', alt: 'Fcc', img: fcc, link: 'https://www.fcc.gov/ ', bg: true },
  {
    key: 'elpasocounty',
    alt: 'Elpasocounty',
    img: elpasocounty,
    link:
      'https://www.elpasocountyhealth.org/prevention-services/tobacco-education-prevention/',
  },
  { key: 'evergy', alt: 'Evergy', img: evergy, link: 'https://evergy.com/' },
  { key: 'dir', alt: 'Dir', img: dir, link: 'https://www.dir.ca.gov/dosh/' },
  {
    key: 'dhs',
    alt: 'Dhs',
    img: dhs,
    link:
      'https://dhs.saccounty.gov/PUB/Pages/Communicable-Disease-Control/GI-TB-Control.aspx',
    bg: true,
  },
  {
    key: 'democracy',
    alt: 'Democracy',
    img: democracy,
    link: 'https://democracyprep.org/',
  },
  { key: 'cpw', alt: 'Cpw', img: cpw, link: 'https://cpw.state.co.us/' },
  { key: 'cppa', alt: 'Cppa', img: cppa, link: 'https://cppa.ca.gov/' },
  {
    key: 'coronatools',
    alt: 'Coronatools',
    img: coronatools,
    link: 'https://coronatools.com/',
  },
  {
    key: 'connecthealth',
    alt: 'Connecthealth',
    img: connecthealth,
    link: 'https://connectforhealthco.com/get-started/omnisalud/',
  },
  {
    key: 'communitymedical',
    alt: 'Communitymedical',
    img: communitymedical,
    link: 'https://www.communitymedicalgroup.com/en/',
  },
  {
    key: 'communitycaretx',
    alt: 'Communitycaretx',
    img: communitycaretx,
    link:
      'https://communitycaretx.org/all-locations/del-valle-health-and-wellness-center/',
  },
  { key: 'clchc', alt: 'Clchc', img: clchc, link: 'https://www.clchc.org/' },
  {
    key: 'christiana',
    alt: 'Christiana',
    img: christiana,
    link: 'https://christianacare.org/us/en',
  },
  {
    key: 'chenmend',
    alt: 'Chenmend',
    img: chenmend,
    link: 'https://www.chenmed.com/',
  },
  {
    key: 'cdphe',
    alt: 'Cdphe',
    img: cdphe,
    link: 'https://cdphe.colorado.gov/',
  },
  {
    key: 'dbw',
    alt: 'Dbw',
    img: dbw,
    link: 'https://dbw.parks.ca.gov/',
  },
  { key: 'cdph', alt: 'Cdph', img: cdph, link: 'https://www.cdph.ca.gov/' },
  {
    key: 'cdhs',
    alt: 'Cdhs',
    img: cdhs,
    link: 'https://cdhs.colorado.gov/',
  },
  { key: 'cccco', alt: 'Cccco', img: cccco, link: 'https://www.cccco.edu/' },
  {
    key: 'canohealth',
    alt: 'Canohealth',
    img: canohealth,
    link: 'https://canohealth.com/',
  },
  {
    key: 'calfire',
    alt: 'Calfire',
    img: calfire,
    link: 'https://www.fire.ca.gov/',
  },
  {
    key: 'burnet',
    alt: 'Burnet',
    img: burnet,
    link: 'https://www.burnetcountytexas.org/',
  },
  {
    key: 'anthem',
    alt: 'Anthem',
    img: anthem,
    link: 'https://www.anthem.com/',
  },
  {
    key: 'altamed',
    alt: 'Altamed',
    img: altamed,
    link: 'https://www.altamed.org/',
  },
  { key: 'aetna', alt: 'Aetna', img: aetna, link: 'https://www.aetna.com/' },

  // ORIGINAL LIST CONTINUED REVERSED
  {
    key: 'tampico',
    alt: 'Tampico',
    img: tampico,
    link: 'http://www.tampico.com/',
  },
  { key: 'tums', alt: 'Tums', img: tums, link: 'https://www.tums.com/' },
  {
    key: 'glidden',
    alt: 'Glidden',
    img: glidden,
    link: 'https://www.glidden.com/',
  },
  {
    key: 'bandai',
    alt: 'Bandai',
    img: bandai,
    link: 'https://www.bandainamcoent.com/',
  },
  {
    key: 'nongshim',
    alt: 'Nongshim',
    img: nongshim,
    link: 'http://www.nongshimusa.com/homev2/bowl-noodle/',
  },
  {
    key: 'volaris',
    alt: 'Volaris',
    img: volaris,
    link: 'https://www.volaris.com/',
  },
  {
    key: 'endowment',
    alt: 'Endowment',
    img: endowment,
    link: 'https://www.calendow.org/',
  },
  {
    key: 'metropolitan',
    alt: 'Metropolitan',
    img: metropolitan,
    link: 'http://www.mwdh2o.com/',
  },
  {
    key: 'california',
    alt: 'California',
    img: california,
    link: 'http://www.dbw.parks.ca.gov/',
  },
  {
    key: 'cdc',
    alt: 'Cdc',
    img: cdc,
    link: 'https://www.cdc.gov/zika/prevention/index.html',
  },
  { key: 'xcel', alt: 'Xcel', img: xcel, link: 'https://www.xcelenergy.com/' },
  {
    key: 'money',
    alt: 'Money',
    img: money,
    link: 'http://global.moneygram.com/',
  },
  {
    key: 'western',
    alt: 'Western',
    img: western,
    link: 'https://www.westernunion.com/ph/en/home.html',
  },
  {
    key: 'azteca',
    alt: 'Azteca',
    img: azteca,
    link: 'https://www.tvazteca.com/',
  },
  {
    key: 'telemundo',
    alt: 'Telemundo',
    img: telemundo,
    link: 'https://www.telemundo.com/',
  },
  { key: 'espn', alt: 'Espn', img: espn, link: 'http://tv5.espn.com/' },
  {
    key: 'reilly',
    alt: 'Reilly',
    img: reilly,
    link: 'https://www.oreillyauto.com/',
  },
  {
    key: 'tobacco',
    alt: 'Tobacco',
    img: tobacco,
    link: 'https://tobaccofreeca.com/',
  },
  {
    key: 'medicaid',
    alt: 'Medicaid',
    img: medicaid,
    link: 'https://medicaid-help.org/',
  },
  { key: 'dewalt', alt: 'Dewalt', img: dewalt, link: 'https://dewalt.global/' },
  {
    key: 'lcalottery',
    alt: 'Lcalottery',
    img: lcalottery,
    link: 'https://www.calottery.com/',
  },
  {
    key: 'hdsupply',
    alt: 'Hdsupply',
    img: hdsupply,
    link: 'http://www.hdsupply.com/',
  },
  { key: 'lowes', alt: 'Lowes', img: lowes, link: 'https://www.lowes.com/' },
  {
    key: 'homedepot',
    alt: 'Homedepot',
    img: homedepot,
    link: 'http://www.homedepot.com/',
  },
  {
    key: 'cricket',
    alt: 'Cricket',
    img: cricket,
    link: 'https://www.cricketwireless.com/',
  },
  {
    key: 'boost',
    alt: 'Boost',
    img: boost,
    link: 'https://www.boostmobile.com/',
  },
  {
    key: 'metroByT',
    alt: 'Metro By T',
    img: metroByT,
    link: 'https://www.metropcs.com/',
  },
  {
    key: 'dickies',
    alt: 'Dickies',
    img: dickies,
    link: 'https://www.dickies.com/',
  },
  {
    key: 'moctezuma',
    alt: 'Moctezuma',
    img: moctezuma,
    link: 'https://heinekenmexico.com/',
  },
  {
    key: 'busch',
    alt: 'Busch',
    img: busch,
    link: 'https://www.anheuser-busch.com/',
  },
  {
    key: 'modelo',
    alt: 'Modelo',
    img: modelo,
    link: 'https://www.gmodelo.mx/login',
  },
  {
    key: 'pepsico',
    alt: 'Pepsico',
    img: pepsico,
    link: 'https://www.pepsico.com/',
  },
  {
    key: 'jarritos',
    alt: 'Jarritos',
    img: jarritos,
    link: 'https://jarritos.com/',
  },
  {
    key: 'beam',
    alt: 'Beam',
    img: beam,
    link: 'https://www.beamsuntory.com/brands/hornitos',
  },
  {
    key: 'miller',
    alt: 'Miller',
    img: miller,
    link: 'https://jobs.molsoncoors.com/MillerCoors',
  },
]
